// extracted by mini-css-extract-plugin
export default {"base":"VideoItem--base--jP8iK","video":"VideoItem--video--ie0b5"};